<template>
<div v-if="visible" style="position:fixed;right:84px;bottom:44px;width:270px">
  <v-col align="right">
    <div class="title grey--text text-center mb-4">{{ $t('panel.hint_add_device') }}</div>
    <img :width="128" :height="128" src="@/assets/right-drawn-arrow.svg" />
  </v-col>
</div>
</template>

<script>
export default {
  name: 'AddNewDeviceHint',
  props: {
    visible: {
      type: Boolean
    }
  }
}
</script>
